export default {"src":"/login-app/[GIT_HASH]/_next/static/media/x_filled.196a57c3.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};